<template>
<div class="chapter">
<div class="inner_page">
<p class="image-h"><a id="page_6"><img alt="image" src="html/images/f0006-01.jpg"/></a></p><a id="page_6">
<p class="h3" id="lev173">THE RACE HORSE.</p>
</a><p class="noindent"><a id="page_6">IN Great Britain, the breed of Horses seems to be as mixed as that of its inhabitants. By great attention to the improvement of this noble animal, by a judicious mixture of several kinds, and by superior skill in management, the English Race Horse</a><span href="#/html/9780226044859_233_not#pg6fn1" id="rpg6fn1" title="Link target outside of Sample">*<sup>2</sup></span> is allowed to excel those of the rest of <a id="page_7">Europe, or perhaps the whole world. For supporting a continuance of violent exertion (or what is called, in the language of the turf, <em>bottom)</em>, they are superior to the Arabian, the Barb, or the Persian; and for swiftness, they will yield the palm to none. An ordinary Racer is known to go at the rate of a mile in less than two minutes; but there have been instances of much greater rapidity; the famous Horse, Childers, has been known to move eighty-two feet and a half in a second, or nearly a mile in a minute; he has run round the course at Newmarket, which is little less than four miles, in six minutes and forty seconds.</a></p><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226044859_10_ch2.vue?67528bf2